import getUser from './getUser'

const isBrowser = typeof window !== `undefined`

const getCurrentUser = () => isBrowser && getUser()

export default getCurrentUser
